export * from "./layout";
export * from "./pages";
export * from "./home";
export * from "./platform";
export * from "./payall-story";
export * from "./payall-life";
export * from "./solutions";
export * from "./automation";
export * from "./payment-orchestration";
export * from "./end-user-apps";
export * from "./central-banks";
export * from "./payment-channels";
export * from "./ecosystem";
export * from "./originating-institutions";
export * from "./swiper";
export * from "./resources";
export * from "./post";
export * from "./form";
export * from "./lead-gen";
export * from "./leadership";
export * from "./investor";
export * from './p2p-money-abroad';

export * from "./content-manager";
export * from "./cta";
export * from "./image";
export * from "./link";
export * from "./next-page";
export * from "./tags";
export * from "./text-cols";
export * from "./image-link";
export * from "./image-link-gallery";
export * from "./contact-modal";
